
import { FormattedRpServiceConfigurationServiceOffering } from "@idw-types/data/rp-service-configuration";
import { FormattedRpServiceConfigurationScoreModifier } from "@idw-types/data/rp-service-configuration/rp-service-configuration-score";
import { ScoreReferenceData } from "@idw-types/data/rp-service-configuration/scores/score-reference-data";
import { ScoreModifiersTableContainer } from "../../score-table-container/score-table-container";

type TrustScoreModifiersTableContainerProps = {
    isDisabled: boolean;
    trustScoreModifiers: Array<FormattedRpServiceConfigurationScoreModifier>;
    canViewPassTrustScoreModifiers: boolean;
    canViewCloseTrustScoreModifiers: boolean;
    canViewPartialTrustScoreModifiers: boolean;
    canViewUnverifiedTrustScoreModifiers: boolean;
    canViewFailTrustScoreModifiers: boolean;
    scoreReferenceData: ScoreReferenceData;
    formattedServiceOfferings: Array<
        FormattedRpServiceConfigurationServiceOffering
    >;
    setTrustScoreModifiersState: (
        trustScoreModifiers: Array<FormattedRpServiceConfigurationScoreModifier>
    ) => void;
};

export type TrustScoreModifierTableDataRow = FormattedRpServiceConfigurationScoreModifier & {
    assertionName: string;
    serviceOfferingName: string;
};

export const TrustScoreModifiersTableContainer = (
    props: TrustScoreModifiersTableContainerProps
) => {
    const {
        isDisabled,
        trustScoreModifiers,
        canViewPassTrustScoreModifiers,
        canViewCloseTrustScoreModifiers,
        canViewPartialTrustScoreModifiers,
        canViewUnverifiedTrustScoreModifiers,
        canViewFailTrustScoreModifiers,
        scoreReferenceData,
        formattedServiceOfferings,
        setTrustScoreModifiersState,
    } = props;


    return (
        <ScoreModifiersTableContainer
            isDisabled={isDisabled}
            scoreModifiers={trustScoreModifiers}
            canViewPassScoreModifiers={canViewPassTrustScoreModifiers}
            canViewCloseScoreModifiers={canViewCloseTrustScoreModifiers}
            canViewPartialScoreModifiers={canViewPartialTrustScoreModifiers}
            canViewUnverifiedScoreModifiers={canViewUnverifiedTrustScoreModifiers}
            canViewWarnScoreModifiers={canViewUnverifiedTrustScoreModifiers}
            canViewFailScoreModifiers={canViewFailTrustScoreModifiers}
            assertions={scoreReferenceData.assertions}
            availableAssertionStatuses={scoreReferenceData.availableAssertionStatuses}
            availableScoreValues={scoreReferenceData.availableTrustScoreValues}
            scoreAssertionStatusValueMaps={scoreReferenceData.trustScoreAssertionStatusValueMaps}
            formattedServiceOfferings={formattedServiceOfferings}
            setScoreModifiersState={setTrustScoreModifiersState}
        />

    );
};
